import { Controller } from '@hotwired/stimulus'
import { useDebounce } from 'stimulus-use'
import { get } from '@rails/request.js'
import { sendError } from '../utils'

export default class extends Controller {
  static debounces = ['submit']
  static targets = ['query', 'results', 'clearButton']

  static values = {
    previewPath: String,
    debounceTimeout: { type: Number, default: 300 },
    resultsId: { type: String, default: 'search_results' },
  }

  connect() {
    useDebounce(this, { wait: this.debounceTimeoutValue })
    this.toggleClearButton()
  }

  disconnect() {
    this.hideSearchResults()
  }

  hideResultsIfOutsideClick(e) {
    if (e && this.element.contains(e.target)) return

    this.hideSearchResults()
  }

  hideSearchResults() {
    if (this.hasResultsTarget) this.resultsTarget.hidden = true
  }

  showSearchResults() {
    if (this.hasResultsTarget) this.resultsTarget.hidden = false
  }

  autofocus() {
    this.queryTarget.focus()
    this.queryTarget.setSelectionRange(this.#queryValue.length, this.#queryValue.length)
  }

  clear() {
    this.queryTarget.value = ''
    this.queryTarget.focus()
    this.toggleClearButton()
    this.submit()
  }

  toggleClearButton() {
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.hidden = this.#queryValue === ''
    }
  }

  submit() {
    this.dispatch('query', { detail: { query: this.#queryValue } })

    if (!this.hasResultsTarget) {
      this.element.requestSubmit()
      return
    }

    if (this.#queryValue === '') {
      this.resultsTarget.innerHTML = ''
      return
    }

    get(this.#uri, { responseKind: 'turbo-stream' }).catch((error) => {
      console.error('Error fetching turbo stream:', error)
      sendError(error, this.identifier, { method: 'submit', url })
    })

    this.dispatch('submit', { detail: { content: this.#queryValue } })
  }

  get #uri() {
    const uri = new URL(this.previewPathValue, document.location)
    uri.searchParams.set('q', this.#queryValue)
    uri.searchParams.set('results_id', this.resultsIdValue)
    return uri
  }

  get #queryValue() {
    return this.queryTarget.value
  }
}
